import { AssignmentStatus } from '@rematter/frontend-lib-api-client';

import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';
import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useServiceAssignMutation = createMutationHook(
  'transportation.serviceAssign',
  (params: {
    id: string;
    assignmentStatus: AssignmentStatus;
    driverId?: string;
    haulerId?: string;
    truckId?: string;
    trailerId?: string;
    estimatedArrival?: string;
  }) => ({
    transportationServiceAssign: {
      __args: {
        input: {
          id: params.id,
          assignmentStatus: params.assignmentStatus,
          driverId: params.driverId,
          haulerId: params.haulerId,
          truckId: params.truckId,
          trailerId: params.trailerId,
          estimatedArrival: params.estimatedArrival,
        },
      },
      ...SERVICE_FRAGMENT,
    },
  }),
  {
    select: ({ transportationServiceAssign: service }) => mapService(service),
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
